import { ChevronLeft, ChevronRight } from 'tabler-icons-react';
import Pagination from 'react-js-pagination';
import styles from 'partials/pagination.module.scss';

export const DataPagination = (props) => {
	return (
		<Pagination
			hideFirstLastPages
			totalItemsCount={props.totalItemsCount}
			itemsCountPerPage={props.itemsCountPerPage || 10}
			pageRangeDisplayed={props.pageRangeDisplayed || 5}
			activePage={props.activePage}
			prevPageText={<ChevronLeft className={styles.arrowIcon} />}
			nextPageText={<ChevronRight className={styles.arrowIcon} />}
			innerClass={styles.pagination}
			linkClass={styles.num}
			activeLinkClass={styles.current}
			disabledClass={styles.disabled}
			itemClassPrev={styles.arrow}
			itemClassNext={styles.arrow}
			onChange={props.onChange}
		/>
	);
};
